var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3806_12209)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3806_12209",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 20,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6,
    y: 4,
    width: 20,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5C20.9707 5 25 9.02778 25 13.9961C25 15.5923 24.582 17.09 23.8525 18.3896H23.876L19.9092 25.875C18.4675 28.5948 14.6222 28.7347 12.9863 26.127L8.48438 18.9502L8.48828 18.9492C7.54868 17.5285 7.00003 15.8267 7 13.9961C7 9.02784 11.0294 5.00009 16 5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 5C20.9707 5 25 9.02778 25 13.9961C25 15.5923 24.582 17.09 23.8525 18.3896H23.876L19.9092 25.875C18.4675 28.5948 14.6222 28.7347 12.9863 26.127L8.48438 18.9502L8.48828 18.9492C7.54868 17.5285 7.00003 15.8267 7 13.9961C7 9.02784 11.0294 5.00009 16 5Z",
    fill: "#54CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5V4H16L16 5ZM25 13.9961L26 13.9961V13.9961H25ZM23.8525 18.3896L22.9805 17.9002L22.1445 19.3896H23.8525V18.3896ZM23.876 18.3896L24.7596 18.8579L25.5377 17.3896H23.876V18.3896ZM19.9092 25.875L20.7927 26.3434L20.7928 26.3433L19.9092 25.875ZM12.9863 26.127L12.1392 26.6583L12.1392 26.6584L12.9863 26.127ZM8.48438 18.9502L8.24184 17.9801L6.90499 18.3143L7.63725 19.4816L8.48438 18.9502ZM8.48828 18.9492L8.73082 19.9194L10.1021 19.5765L9.32237 18.3976L8.48828 18.9492ZM7 13.9961H6V13.9961L7 13.9961ZM16 5V6C20.4188 6 24 9.58046 24 13.9961H25H26C26 8.4751 21.5225 4 16 4V5ZM25 13.9961L24 13.9961C24 15.4154 23.6288 16.7452 22.9805 17.9002L23.8525 18.3896L24.7246 18.8791C25.5352 17.4348 26 15.7692 26 13.9961L25 13.9961ZM23.8525 18.3896V19.3896H23.876V18.3896V17.3896H23.8525V18.3896ZM23.876 18.3896L22.9924 17.9214L19.0256 25.4067L19.9092 25.875L20.7928 26.3433L24.7596 18.8579L23.876 18.3896ZM19.9092 25.875L19.0256 25.4066C17.9444 27.4464 15.0604 27.5515 13.8334 25.5956L12.9863 26.127L12.1392 26.6584C14.184 29.918 18.9905 29.7431 20.7927 26.3434L19.9092 25.875ZM12.9863 26.127L13.8335 25.5956L9.3315 18.4188L8.48438 18.9502L7.63725 19.4816L12.1392 26.6583L12.9863 26.127ZM8.48438 18.9502L8.72691 19.9203L8.73082 19.9194L8.48828 18.9492L8.24575 17.9791L8.24184 17.9801L8.48438 18.9502ZM8.48828 18.9492L9.32237 18.3976C8.48722 17.1348 8.00003 15.6238 8 13.9961L7 13.9961L6 13.9961C6.00004 16.0296 6.61014 17.9222 7.65419 19.5008L8.48828 18.9492ZM7 13.9961H8C8 9.58053 11.5813 6.00008 16 6L16 5L16 4C10.4775 4.0001 6 8.47514 6 13.9961H7Z",
    fill: "white",
    mask: "url(#path-1-outside-1_3806_12209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5834 9.33362C16.5834 9.01145 16.3222 8.75028 16.0001 8.75028C15.6779 8.75028 15.4167 9.01145 15.4167 9.33362C15.4167 9.65578 15.6779 9.91695 16.0001 9.91695C16.3222 9.91695 16.5834 9.65578 16.5834 9.33362ZM17.7501 9.33362C17.7501 10.0953 17.2627 10.7412 16.5834 10.9816V12.8336H17.7501C18.0722 12.8336 18.3334 13.0948 18.3334 13.417C18.3334 13.7391 18.0722 14.0003 17.7501 14.0003H16.5834V18.6288C17.6059 18.4999 18.5636 18.0368 19.3001 17.3003C19.9359 16.6646 20.3673 15.8637 20.5568 14.9989L20.3443 15.1054C20.0562 15.2495 19.7057 15.1327 19.5616 14.8445C19.4175 14.5564 19.5344 14.2059 19.8225 14.0618L20.9892 13.4785C21.17 13.3881 21.3846 13.3979 21.5566 13.5041C21.7285 13.6104 21.8334 13.7981 21.8334 14.0003C21.8334 15.5474 21.219 17.0312 20.125 18.1252C19.1694 19.0808 17.9163 19.6701 16.5834 19.804V19.8336C16.5834 20.1558 16.3222 20.417 16.0001 20.417C15.6779 20.417 15.4167 20.1558 15.4167 19.8336V19.804C14.0839 19.6701 12.8307 19.0808 11.8752 18.1252C10.7812 17.0312 10.1667 15.5474 10.1667 14.0003C10.1667 13.7981 10.2716 13.6104 10.4436 13.5041C10.6156 13.3979 10.8302 13.3881 11.011 13.4785L12.1777 14.0618C12.4658 14.2059 12.5826 14.5564 12.4386 14.8445C12.2945 15.1327 11.944 15.2495 11.6558 15.1054L11.4428 14.9989C11.6323 15.8637 12.0642 16.6645 12.7 17.3003C13.4365 18.0368 14.3942 18.4999 15.4167 18.6288V14.0003H14.2501C13.9279 14.0003 13.6667 13.7391 13.6667 13.417C13.6667 13.0948 13.9279 12.8336 14.2501 12.8336H15.4167V10.9816C14.7374 10.7412 14.2501 10.0953 14.2501 9.33362C14.2501 8.36712 15.0336 7.58362 16.0001 7.58362C16.9666 7.58362 17.7501 8.36712 17.7501 9.33362Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3806_12209",
    x: 0,
    y: 0,
    width: 32,
    height: 37.0015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3806_12209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3806_12209",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPort);
export default __webpack_public_path__ + "static/media/port.90359d3e017cacb01987ee9a0c86086f.svg";
export { ForwardRef as ReactComponent };